<div style="width: 100%;padding: 0 20px;">
  <h3 class="heading">Settings</h3>
<div class="settings-container">
<!-- Sidebar Navigation -->
<aside class="sidebar">

  <ul>
    <li [class.active]="selectedTabs === 'terms'" (click)="selectTabs('terms')">Terms & Conditions</li>
    <li [class.active]="selectedTabs === 'website'" (click)="selectTabs('website')">Website Settings</li>
    <li [class.active]="selectedTabs === 'ratecard'" (click)="selectTabs('ratecard')">Labour RateCard</li>
  </ul>
</aside>

<!-- Main Content Area -->
<section class="content" *ngIf="selectedTabs === 'terms'">
  <h2>Terms and Conditions</h2>
  
  <!-- Tabs -->
  <div class="buttons" >
      <button class="request-button" 
              [ngClass]="{'active': selectedTab === 'jobCard'}"
              (click)="selectTab('jobCard')">JOB CARD</button>
      <button class="request-button" 
              [ngClass]="{'active': selectedTab === 'quotation'}"
              (click)="selectTab('quotation')">CUSTOMER QUOTATION </button>
      <button class="request-button" 
              [ngClass]="{'active': selectedTab === 'invoice'}"
              (click)="selectTab('invoice')">INVOICE</button>
    </div>

  <!-- Tab Content -->
  <div *ngIf="selectedTab === 'jobCard'">
    <div class="matformfieldnew">
      <mat-form-field appearance="outline" style="width: 100%;">
      <!-- <mat-form-field  class="custom-mat-form-field"> -->
        <!-- <div class="custom-textarea-container"> -->
          <mat-label>Add Terms & Conditions</mat-label>
          <textarea matInput [(ngModel)]="jobCardTerms" rows="15" style="text-align: left;"></textarea>
        <!-- </div> -->
      </mat-form-field>   
  </div> 
  </div>
  <div *ngIf="selectedTab === 'quotation'">
    <div class="matformfieldnew">
      <mat-form-field appearance="outline" style="width: 100%;">
      <!-- <mat-form-field  class="custom-mat-form-field"> -->
        <!-- <div class="custom-textarea-container"> -->
          <mat-label>Add Terms & Conditions</mat-label>
          <textarea matInput [(ngModel)]="quotationTerms" rows="15" style="text-align: left;"></textarea>
        <!-- </div> -->
      </mat-form-field>   
  </div> 
  </div>
  <div *ngIf="selectedTab === 'invoice'">
    <div class="matformfieldnew">
      <mat-form-field appearance="outline" style="width: 100%;">
      <!-- <mat-form-field  class="custom-mat-form-field"> -->
        <!-- <div class="custom-textarea-container"> -->
          <mat-label>Add Terms & Conditions</mat-label>
          <textarea matInput [(ngModel)]="invoiceTerms" rows="15" style="text-align: left;"></textarea>
        <!-- </div> -->
      </mat-form-field>   
  </div> 
  </div>

  <!-- Save Button -->
  <button class="save-btn" (click)="createTermsAndConditions()">Save Terms & Conditions</button>
</section>
</div>

</div>
<section class="content" *ngIf="selectedTabs === 'website'">
  <div #dynamicContainer></div>
</section>
<section class="content" *ngIf="selectedTabs === 'ratecard'">
  <div #dynamicContainer1></div>
</section>


